export default class Building {
  id = null;
  name = "";
  objectNumber = "";
  address_street = "";
  address_zip = "";
  address_city = "";
  country = 0;
  province = null;
  latitude = null;
  longitude = null;
  owner = null;
  operator = null;
  billing_street = "";
  billing_zip = "";
  billing_city = "";
  billingPersonName = "";
  billingVatId = "";
  imagePath = "";

  roleCount = 0;
  facilityCount = 0;
  createdAt = "";
  createdBy = "";
  updatedAt = "";

  constructor() {
  }
}
